


































import HeaderLayout from '@/components/Header.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import GetKakaoTokenHandler from '@/mixins/GetKakaoTokenHandler'
import {SignInKakaoPayload} from '@/store/modules/auth/types'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {namespace} from 'vuex-class'
import {Component, Mixins, Prop} from 'vue-property-decorator'

const invitation = namespace('invitation')
const auth = namespace('auth')
const layout = namespace('layout')
const gtm = namespace('gtm')

@Component({
  components: {FooterButton, HeaderLayout, MainLayout, FooterLayout},
})
export default class WrongAccessPage extends Mixins(Translation, GetKakaoTokenHandler, Assets) {
  @Prop({default: 'terms', type: String}) translation: string

  @invitation.State('bizName') bizName
  @invitation.State('creatorName') creatorName
  @invitation.State('bizId') bizId
  @invitation.State('invitationId') invitationId
  @auth.Action('connectKakao') connectKakao: (payload?: {then?: string}) => Promise<void>
  @auth.Action('signInKakao') signInKakao: (payload?: SignInKakaoPayload) => void
  @auth.Action('getUser') getUser
  @layout.Mutation('updateError') updateError
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  loading: boolean = false

  created() {
    const {code, logEventWithGroups} = this
    logEventWithGroups({
      eventType: 'start',
      eventProperties: {
        'workflow' : 'sign_up_by_invitation',
        'invitation_id': this.invitationId,
      },
    })
    if(!code) {
      return
    }
    this.loading = true
    this.getKakaoTokenByCode(code)
      .then(() => {return this.connectKakao()})
      .then(() => {this.goNext()})
      .catch((error) => {
        this.loading = false
        this.updateError({
          id: 'failed-to-connect-kakao',
          message: `${this.ts('kakao')} 계정 로그인에 실패하였습니다.`
        })
        throw error
      })
  }

  onClickFooter() {
    this.loading = true
    const {fullPath, name = '', params: {invitationId = ''}} = this.$route
    this.signInKakao({then: fullPath, from: {name, params: {invitationId}}})
  }

  goNext() {
    this.$router.push({name: 'invitation-name'}).catch((e) => e)
  }
}
